import {
  BestActionInputV2,
  BestActionResultV2,
  Query,
  WizardNameV2,
} from '@varo/graphql-schema-types';
import GetBestAction from 'services/graphql/queries/GetBestAction';
import { Maybe } from 'shared/utils/types';
import { CombinedError, useQuery } from 'urql';

interface BestActionResult {
  nextBestActionLoading: boolean;
  error?: CombinedError;
  nextBestActionData?: Maybe<BestActionResultV2>;
  shouldCloseWizard?: boolean;
  fetchNextBestAction: () => void;
}

const useGetBestAction = (
  wizardName: Maybe<WizardNameV2>,
  wizardId: Maybe<string>,
): BestActionResult => {
  const input: BestActionInputV2 = {
    id: wizardId ?? undefined,
    ...(!wizardId &&
      wizardName && {
        params: {
          name: wizardName,
        },
      }),
  };

  const [{ data, fetching, error }, fetchNextBestAction] = useQuery<Query>({
    query: GetBestAction,
    requestPolicy: 'cache-and-network',
    variables: {
      input,
    },
    pause: true,
  });

  const nextBestActionData = data?.bestActionV2;

  return {
    nextBestActionLoading: fetching,
    error,
    nextBestActionData,
    shouldCloseWizard: nextBestActionData === null && !fetching,
    fetchNextBestAction,
  };
};

export default useGetBestAction;
